import { Combobox } from '@Components/Combobox';
import { useVenues } from '@Hooks/useVenues';
import { cn } from '@Utils/cn';

export function VenueQuickFilter({
  venueFilter,
  handleChangeVenue,
  triggerClassName,
}: {
  venueFilter: string;
  handleChangeVenue: (newVenueId: string) => void;
  triggerClassName?: string;
}) {
  const { data: venues, isLoading } = useVenues({ enabled: true });

  const venueItems = [
    { value: '', label: 'All venues' },
    ...(venues ?? [])
      .map((venue) => ({
        value: venue.id,
        label: venue.name,
      }))
      .sort((a, b) =>
        a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }),
      ),
  ];

  return (
    <Combobox
      id="venueFilter"
      items={venueItems}
      value={venueFilter}
      onChange={handleChangeVenue}
      placeholder="All venues"
      disabled={!venues?.length}
      loading={isLoading}
      triggerClassName={cn('w-[200px]', triggerClassName)}
    />
  );
}
